import React from 'react';

import { WebhookOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import StripeImage from './Stripe.svg';
import WaypointImage from './Waypoint.svg';

type Props = {
  type: 'STRIPE' | 'WAYPOINT_API' | 'HTTP_POST';
};

export default function ServiceIcon({ type }: Props) {
  switch (type) {
    case 'STRIPE':
      return <Box component="img" src={StripeImage} alt="Stripe" sx={{ maxWidth: 24 }} />;
    case 'WAYPOINT_API':
      return <Box component="img" src={WaypointImage} alt="Waypoint API" sx={{ maxWidth: 24 }} />;
    case 'HTTP_POST':
      return <WebhookOutlined />;
  }
}
